export enum DEPARTMENTS {
  REQUEST = 'DEPARTMENTS_REQUEST',
  SUCCESS = 'DEPARTMENTS_SUCCESS',
  FAILURE = 'DEPARTMENTS_FAILURE'
}
